export default __webpack_public_path__ + "static/media/nairaw.0e31bfac.svg";